import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  SIGN_MAPPING,
} from 'utils';

import CompatibilityImageSimple from '../../assets/compatibility_icon_plain.png';
import SignImagePlaceholder from '../../assets/placeholder_stars.svg';

import {
  ChosenSigns,
  ChosenSignImg,
  CompatibilityIconSimple,
  SignImagesWrapper,
  InfoTitle,
  CompatibilityInfo,
} from './CompatibilityReport.styles';

const CompatibilityReport = (props) => {
  const { yourSign, partnerSign, report, percentage } = props.compatibility;

  const yourSignLowerCase = yourSign
    ? yourSign.toLowerCase()
    : null;
  const partnerSignLowerCase = partnerSign
    ? partnerSign.toLowerCase()
    : null;
  const yourSignImage = yourSignLowerCase
    ? SIGN_MAPPING[yourSignLowerCase].starImage
    : SignImagePlaceholder;
  const partnerSignImage = partnerSignLowerCase
    ? SIGN_MAPPING[partnerSignLowerCase].starImage
    : SignImagePlaceholder;

  return (
    <React.Fragment>
      <ChosenSigns>
        {yourSign || null} & {partnerSign || null}
      </ChosenSigns>
      <SignImagesWrapper>
        <ChosenSignImg src={ yourSignImage } alt={`Your sign chosen as ${yourSign} for compatibility calculator`} />
        <CompatibilityIconSimple src={ CompatibilityImageSimple } alt={`Heart Icon to show compatibility between ${yourSign} and ${partnerSign}`} height="35" />
        <ChosenSignImg src={ partnerSignImage } alt={`Your partner's sign as ${partnerSign} for compatibility calculator`} />
      </SignImagesWrapper>
      <InfoTitle center>You are {percentage || `--`}% compatible</InfoTitle>
      <CompatibilityInfo>
        {report || `Loading...`}
      </CompatibilityInfo>
    </React.Fragment>
  );
};

CompatibilityReport.propTypes = {
  compatibility: PropTypes.object,
};

export default connect((state) => ({
  compatibility: state.compatibility,
}), {})(CompatibilityReport);
